import fetch from "isomorphic-fetch";
import groupby from "lodash.groupby";

export const TOGGLE_HASHTAG = "TOGGLE_HASHTAG";
export const UPDATE_INPUT = "UPDATE_INPUT";
export const FETCH_HASHTAGS_REQUEST = "FETCH_HASHTAGS_REQUEST";
export const FETCH_HASHTAGS_SUCCESS = "FETCH_HASHTAGS_SUCCESS";

export function toggleHashtag(hashtagId) {
  return {
    type: TOGGLE_HASHTAG,
    hashtagId
  };
}

export function updateInput(inputId) {
  return {
    type: UPDATE_INPUT,
    inputId
  };
}

export const fetchHashtagsRequest = hashtags => {
  return { type: FETCH_HASHTAGS_REQUEST, hashtags, query: hashtags };
};

export const fetchHashtagsSuccess = items => {
  const itemsByCount = {};
  items.forEach(x => {
    if (itemsByCount[x.media_count]) {
      itemsByCount[x.media_count].push(x.name);
    } else {
      itemsByCount[x.media_count] = [x.name];
    }
  });
  const groups = Object.values(groupby(items, "media_count"));
  return {
    type: FETCH_HASHTAGS_SUCCESS,
    items,
    itemsByCount,
    groups,
    shouldShowSlider: true
  };
};

export function fetchHashtags(hashtags) {
  return dispatch => {
    if (!hashtags) {
      return;
    }
    dispatch(fetchHashtagsRequest(hashtags));
    return fetch("https://hashtagfetcher-api.herokuapp.com/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: hashtags,
        agent: 666666
      })
    })
      .then(response => response.json())
      .then(json => {
        dispatch(fetchHashtagsSuccess(json));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions.js